export const BUSINESSES = 'businesses';
export const SCREEN = 'screen';
export const VERIFY = 'verify';

export default Object.freeze({
  [BUSINESSES]: {
    demoName: 'Businesses Lookup',
    demoUrl: process.env.REACT_APP_BUSINESSES_LOOKUP_URL,
    displayName: 'Businesses',
    namespace: 'verify/usage',
    usagePlanName: 'verify',
    pricingPlans: Object.freeze({
      FREE_TIER: 'verify_free',
      BASIC_TIER: 'verify_basic',
    }),
  },
  [VERIFY]: {
    demoName: 'Verify Demo',
    demoUrl: process.env.REACT_APP_VERIFY_DEMO_URL,
    displayName: 'Verify',
    namespace: 'verify/usage',
    usagePlanName: 'verify',
    pricingPlans: Object.freeze({
      FREE_TIER: 'verify_free',
      BASIC_TIER: 'verify_basic',
    }),
  },
  [SCREEN]: {
    displayName: 'Screen',
    namespace: 'screen/usage',
    usagePlanName: 'screen',
  },
});
